<app-voucher-header></app-voucher-header>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>
<main class="page-content">
  <router-outlet></router-outlet>
  <p-confirmDialog></p-confirmDialog>
  <app-three-button-dialog></app-three-button-dialog>
</main>

<p-dialog header="Session Timeout Warning" [(visible)]="showSessionWarning" [closable]="false" [closeOnEscape]="false"
  [modal]="true" [dismissableMask]="false" [style]="{ width: '420px' }">

  <div class="dialog-body">
    Your session will expire in <strong>{{ countdown }}</strong> seconds due to inactivity.
  </div>

  <ng-template pTemplate="footer">
    <div class="session-timeout-actions">
      <button type="button" class="button-primary" (click)="stayLoggedIn()">
        Stay Connected
      </button>

      <button type="button" class="button-primary" (click)="logoutFromIdlePopup()">
        Logout
      </button>
    </div>
  </ng-template>
</p-dialog>

<app-voucher-footer></app-voucher-footer>